import { Subject } from 'rxjs';
import {
  Perosnlapackages,
  personalFood,
  RatioArray,
  ResponseGetRatioArray,
} from './../../../core/model/api-response/persoanl-response-model';
import { Injectable } from '@angular/core';
import { FoodModel } from 'src/app/core/model/object/diet-food-model';

@Injectable({
  providedIn: 'root',
})
export class PersonalDataService {
  openBottomSheet$: Subject<boolean> = new Subject<boolean>();
  closeBottomSheet$: Subject<boolean> = new Subject<boolean>();
  closeAndRemove$: Subject<string> = new Subject<string>();
  addPeronalpackage$: Subject<[FoodModel, number]> = new Subject();
  closeAndUpdateBottomSheet$: Subject<{
    ratio: ResponseGetRatioArray;
    calorie: number;
  } | null> = new Subject<{
    ratio: ResponseGetRatioArray;
    calorie: number;
  } | null>();

  editFood: personalFood = null;
  ids: string[];
  editRatio: [RatioArray, ResponseGetRatioArray] = null;
  editPersonalPackage: Perosnlapackages = null;
  constructor() {}
  saveForEditFood(food: personalFood) {
    this.editFood = food;
  }
  addPersonalPackage(foodModel: FoodModel, amount: number) {
    this.addPeronalpackage$.next([foodModel, amount]);
  }
  openBottomSheet(data?: [RatioArray, ResponseGetRatioArray], ids?: string[]) {
    if (data) {
      this.editRatio = data;
      this.ids = ids;
    }
    this.openBottomSheet$.next(true);
  }
  closeBottomSheet() {
    this.closeBottomSheet$.next(true);
  }
  closeAndRemove(id: string) {
    // console.log(id);

    this.closeAndRemove$.next(id);
  }
  closeAndUpdateBottomSheet(d: ResponseGetRatioArray, n: number) {
    this.closeAndUpdateBottomSheet$.next({
      calorie: n,
      ratio: d,
    });
  }
  saveIds(ids: string[]) {
    this.ids = ids;
  }
  savePackage(personalP: Perosnlapackages) {
    this.editPersonalPackage = personalP;
  }
  clearPackage() {
    this.editPersonalPackage = null;
  }
  clearEditRatio() {
    this.editRatio = null;
  }
  clearEditFood() {
    this.editFood = null;
  }
}
